export const loginByUserInfo = [
    {"id": 1, "username": "aa", "pew": "123456", "role": "B" , "introduce":"我是管理员"}
  ]


// WEBPACK FOOTER //
// ./src/api/login.js